import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((Theme) => ({
  modal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: Theme.spacing(4),
    marginLeft: Theme.spacing(4),
    margin: 'auto 0',
    [Theme.breakpoints.up('xs')]: {
      marginRight: Theme.spacing(2),
      marginLeft: Theme.spacing(2),
    },
  },
  innerContainer: {
    backgroundColor: Theme.palette.white,
    boxShadow: Theme.shadows[5],
    padding: Theme.spacing(4, 1, 4),
    maxHeight: '70vh',
    overflowY: 'auto',
    [Theme.breakpoints.up('sm')]: {
      padding: Theme.spacing(4, 6, 5),
    },
    [Theme.breakpoints.down('xs')]: {
      width: '90%!important',
      padding: '40px 20px',
    },
    [Theme.breakpoints.between('md', 'lg')]: {
      padding: '40px',
    },
    [Theme.breakpoints.up('lg')]: {
      padding: '50px 60px',
    },
  },
  headerCloseButton: {
    display: 'flex',
    flexDirection: 'row-reverse',
    marginBottom: Theme.typography.size[0],
    cursor: 'pointer',
  },
}));

export default useStyles;
